import { PaginationRequest } from '../config/common';

export class PaginationConsignmentNoteRequest extends PaginationRequest {
    note?: string = '';
    customerID?: string = '';
}

export interface CreateConsignmentNoteRequest {
    note?: string;
    consignmentId: string;
    type?: Number;
}
